export default __webpack_public_path__ + "static/media/score-background.c91f0736.svg";